// Catalogue des articles de l'unité briques & pavés (responsable de l'unité, administrateur).
import React, { useEffect, useState } from 'react';
import {
  Alert, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, MenuItem, Switch,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
} from '@mui/material';
import { AddOutlined, EditOutlined } from '@mui/icons-material';
import Layout from '../../components/Layout';
import { Panel } from '../../components/ui';
import { briquesAPI } from '../../services/api';
import { apiError } from '../../utils/format';
import { tokens } from '../../theme';

const UNITES = ['pièce', 'm²', 'ml', 'm³', 'tonne', 'palette'];

const ArticlesBriques = () => {
  const [d, setD] = useState(null);
  const [dlg, setDlg] = useState(null);
  const [error, setError] = useState('');
  const [dlgError, setDlgError] = useState('');
  const load = () => briquesAPI.articles(true).then((r) => setD(r.data)).catch((e) => setError(apiError(e)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setDlgError('');
    try {
      if (dlg.id) await briquesAPI.modifierArticle(dlg.id, dlg); else await briquesAPI.creerArticle(dlg);
      setDlg(null); load();
    } catch (e) { setDlgError(apiError(e)); }
  };

  return (
    <Layout title="Articles briques & pavés" plain
      actions={d?.gestion && <Button variant="contained" startIcon={<AddOutlined />} onClick={() => { setDlgError(''); setDlg({ code: '', designation: '', famille: 'BRIQUE', unite: 'pièce', position: 200, is_active: true }); }}>Nouvel article</Button>}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Panel flush>
        <TableContainer>
          <Table size="small">
            <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Désignation</TableCell><TableCell>Famille</TableCell><TableCell>Unité</TableCell><TableCell>Ordre</TableCell><TableCell>État</TableCell><TableCell /></TableRow></TableHead>
            <TableBody>
              {d?.articles.map((a) => (
                <TableRow key={a.id} sx={{ opacity: a.is_active ? 1 : 0.55 }}>
                  <TableCell sx={{ fontFamily: tokens.mono, fontWeight: 600 }}>{a.code}</TableCell>
                  <TableCell>{a.designation}</TableCell>
                  <TableCell>{d.familles[a.famille]}</TableCell>
                  <TableCell>{a.unite}</TableCell>
                  <TableCell sx={{ fontFamily: tokens.mono }}>{a.position}</TableCell>
                  <TableCell><Chip size="small" label={a.is_active ? 'Actif' : 'Désactivé'} color={a.is_active ? 'success' : 'default'} variant="outlined" /></TableCell>
                  <TableCell>{d.gestion && <IconButton size="small" aria-label={`Modifier ${a.designation}`} onClick={() => { setDlgError(''); setDlg({ ...a }); }}><EditOutlined fontSize="small" /></IconButton>}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Panel>
      <Dialog open={!!dlg} onClose={() => setDlg(null)} fullWidth maxWidth="xs">
        {dlg && (
          <>
            <DialogTitle>{dlg.id ? `Modifier ${dlg.designation}` : 'Nouvel article'}</DialogTitle>
            <DialogContent sx={{ display: 'grid', gap: 2, pt: '8px !important' }}>
              {dlgError && <Alert severity="error">{dlgError}</Alert>}
              <TextField label="Code" required disabled={!!dlg.id} value={dlg.code} onChange={(e) => setDlg({ ...dlg, code: e.target.value })} placeholder="ex. BC15" />
              <TextField label="Désignation" required value={dlg.designation} onChange={(e) => setDlg({ ...dlg, designation: e.target.value })} placeholder="ex. Brique creuse de 15" />
              <TextField select label="Famille" value={dlg.famille} onChange={(e) => setDlg({ ...dlg, famille: e.target.value })}>
                {Object.entries(d.familles).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
              </TextField>
              <TextField select label="Unité" value={UNITES.includes(dlg.unite) ? dlg.unite : dlg.unite} onChange={(e) => setDlg({ ...dlg, unite: e.target.value })}>
                {[...new Set([...UNITES, dlg.unite])].map((u) => <MenuItem key={u} value={u}>{u}</MenuItem>)}
              </TextField>
              <TextField label="Ordre d'affichage" type="number" value={dlg.position} onChange={(e) => setDlg({ ...dlg, position: e.target.value })} />
              {dlg.id && <FormControlLabel control={<Switch checked={dlg.is_active} onChange={(e) => setDlg({ ...dlg, is_active: e.target.checked })} />} label="Proposé dans le rapport" />}
            </DialogContent>
            <DialogActions><Button onClick={() => setDlg(null)}>Annuler</Button><Button variant="contained" onClick={save}>Enregistrer</Button></DialogActions>
          </>
        )}
      </Dialog>
    </Layout>
  );
};

export default ArticlesBriques;
